__turbopack_context__.v({
  "button": "action-typeform-module-scss-module__gWSXLq__button" + " " + __turbopack_context__.i(495630)["button"] + " " + __turbopack_context__.i(495630)["medium"],
});
